import React from "react";
import { Tags } from "lucide-react";

/* ===================== STYLES ===================== */
import styles from "./RequestHeaders.module.scss";

const RequestHeaders = () => {
  // Extracting hardcoded data into an array for cleaner, map-based rendering
  const headerData = [
    {
      name: "Authorization",
      type: "string",
      required: true,
      description:
        "Type: Basic Auth, username:client_id, password:client_secret / Base64encodedValueOf (client_id:client_secret)",
    },
    {
      name: "Content-Type",
      type: "application/json",
      required: true,
      description: "The only accepted format is application/json",
    },
  ];

  return (
    <div className={styles["admin-req-header__card"]}>
      {/* HEADER SECTION */}
      <div className={styles["admin-req-header__top"]}>
        <div className={styles["admin-req-header__icon-wrapper"]}>
          <Tags size={18} strokeWidth={2.5} />
        </div>
        <h3 className={styles["admin-req-header__title"]}>Request Headers</h3>
      </div>

      {/* TABLE SECTION */}
      <div className={styles["admin-req-header__table-wrapper"]}>
        <table className={styles["admin-req-header__table"]}>
          <thead>
            <tr>
              <th className={styles["admin-req-header__th"]}>Name</th>
              <th className={styles["admin-req-header__th"]}>Type</th>
              <th className={styles["admin-req-header__th"]}>Required</th>
              <th className={styles["admin-req-header__th"]}>Description</th>
            </tr>
          </thead>
          <tbody>
            {headerData.map((row, index) => (
              <tr key={index} className={styles["admin-req-header__tr"]}>
                <td className={styles["admin-req-header__td"]}>
                  <span className={styles["admin-req-header__name"]}>
                    {row.name}
                  </span>
                </td>
                <td className={styles["admin-req-header__td"]}>
                  <span
                    className={`${styles["admin-req-header__badge"]} ${styles["admin-req-header__badge--type"]}`}
                  >
                    {row.type}
                  </span>
                </td>
                <td className={styles["admin-req-header__td"]}>
                  {row.required ? (
                    <span
                      className={`${styles["admin-req-header__badge"]} ${styles["admin-req-header__badge--required"]}`}
                    >
                      Yes
                    </span>
                  ) : (
                    "No"
                  )}
                </td>
                <td className={styles["admin-req-header__td"]}>
                  {row.description}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RequestHeaders;
